import { LitElement, html, nothing } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';
import { classMap } from 'lit/directives/class-map.js';
import { styleMap } from 'lit/directives/style-map.js';
import { isMobile, isEmpty } from '@fil-global/shared/src/util';
import componentStyles from './fil-feature.styles.js';

/**
 * @tag fil-feature
 * @property {"left"|"right"} [alignment="left"]
 * @property {string} [image] URL to a background image
 * @property {string} [smallImage] URL to a background image with small device
 * @property {string} [title] Headline
 */
export class FilFeature extends LitElement {
  static properties = {
    alignment: { type: String }, // 'left' | 'right
    image: { type: String },
    title: { type: String },
    smallImage: { type: String },
    // for trigging update life-cycle
    _usedImage: { type: String, state: true },
  };

  static styles = [componentStyles];

  constructor() {
    super();
    this.alignment = 'left';
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
    super.disconnectedCallback();
  }

  handleResize() {
    const imageContainer = this.shadowRoot.querySelector('.fil-feature__image');

    if (!isEmpty(this.image)) {
      if (!isMobile()) {
        this._usedImage = this.image;
      } else {
        this._usedImage = this.smallImage ? this.smallImage : this.image;
      }
      imageContainer.style.backgroundImage = `url(${this._usedImage})`;
    }
  }

  renderSlot() {
    const classes = {
      'fil-feature-card-wrapper--right': this.alignment !== 'left',
    };

    return html`<div class="cell image-height image-height--auto">
      <div class="fil-feature-card-wrapper${classMap(classes)}">
        <div class="fil-feature-card">
          ${this.title ? html`<h1 class="fil-feature-card__title">${this.title}</h1>` : nothing}
          <div class="fil-feature-card__content">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>`;
  }

  renderImage() {
    const imageUsed = isMobile() ? (this.smallImage ? this.smallImage : this.image) : this.image;
    const classes = {
      'fil-feature-image-wrapper--right': this.alignment !== 'left',
    };
    return html`<div class="fil-feature-image-wrapper${classMap(classes)}">
      <div class="image-container">
        <div
          class="fil-feature__image"
          style=${styleMap({
            backgroundImage: `url(${imageUsed})`,
          })}
        ></div>
        <div class="fil-parallelogram">&nbsp;</div>
        <div class="fil-parallelogram-container--right">
          <div class="fil-parallelogram">&nbsp;</div>
          <div class="fil-parallelogram-last">&nbsp;</div>
        </div>
      </div>
    </div>`;
  }

  render() {
    return html`
      <div class="fil-feature-wrapper">
        <section class="fil-feature">
          ${ifDefined(this.image) ? this.renderImage() : nothing}
          <div class="grid-container position-relative">
            <div class="grid-x ">${this.renderSlot()}</div>
          </div>
        </section>
      </div>
    `;
  }
}

export default FilFeature;
